module.exports = __webpack_public_path__ + "img/axa.95946751.png";